import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import StepNavigation from "./StepNavigation";

const ALLOWED_GROUPS_BY_TYPE = {
  apartment: [
    "about_locality",
    "building_facilities",
    "private_views",
    "technical_equip",
    "inventories",
    "balcony",
  ],

  house: [
    "about_locality",
    "building_facilities",
    "private_views",
    "technical_equip",
    "inventories",
    "balcony",
  ],

  land: [
    "about_locality",
    "private_views",
    "technical_equip",
  ],

country_house: [
    "about_locality",
    "building_facilities",
    "private_views",
    "technical_equip",
    "inventories",
    "balcony",
  ],

hotel: [
    "about_locality",
    "building_facilities",
    "private_views",
    "technical_equip",
    "inventories",
    "balcony",
  ],

commercial_space: [
    "about_locality",
    "building_facilities",
    "private_views",
    "technical_equip",
    "balcony",
  ],
};

const LAND_ALLOWED_ITEMS = {
  technical_equip: [
    "gas",
    "electricity",
    "warm_water",
    "cold_water",
  ],
};


const AMENITIES_GROUPS = {
  about_locality: [
     "near_to_metro","near_to_public_transport","near_to_public_school",
      "near_to_kindergarten","near_to_recreation_area","near_to_market",
      "near_to_pharmacy","near_to_hospital","near_to_police_station",
      "near_to_sports_space","near_to_green_side","near_to_touristic_site",
      "near_to_square","near_to_park","near_to_forest","near_to_city_waters"
  ],
  building_facilities: [
     "private_parking","private_yard","private_recreation","rooftop_recreation",
      "elevator","wheelchair_accessible","free_wifi","security_service",
      "package_lockers","surveillance_camera","green_space","fitness_centre",
      "swimming_pool","spa","business_space","bike_storage","garage","baseeement"
  ],

 private_views: [
      "city_view","mountain_view","water_view","greenside_view","historic_site_view"
    ],

  technical_equip: [
     "television","internet","central_heating","cooling_system","stove","fridge",
      "microwave","dish_washer","hood","washing_machine","tumble_dryer","gas",
      "electricity","warm_water","cold_water","conditioner","priv_surveillance_camera",
      "smart_home"
  ],

 inventories: [
      "ready_to_live","furniture","household_items","decoration",
      "plant_friendly","pet_friendly","exotic_pet_friendly"
    ],
    
    balcony: [
      "balcony","french_balcony","closed_balcony","loggia",
      "terrace","closed_terrace","rooftop","porch"
    ]
};

export default function StepAmenities({
  listing,
  setListing,
  onBack,
  onNext,
}) {
  const { t } = useTranslation();

  const propertyType = listing.type;

const allowedGroups =
  ALLOWED_GROUPS_BY_TYPE[propertyType] || [];

  const selectedAmenities = Array.isArray(listing.amenities)
    ? listing.amenities
    : [];

  // ✅ Ensure amenities is always an array
  useEffect(() => {
    if (!Array.isArray(listing.amenities)) {
      setListing((prev) => ({
        ...prev,
        amenities: [],
      }));
    }
  }, [listing.amenities, setListing]);

useEffect(() => {
  if (!propertyType) return;

  const allowedItems = allowedGroups.flatMap((group) =>
    propertyType === "land" && LAND_ALLOWED_ITEMS[group]
      ? LAND_ALLOWED_ITEMS[group]
      : AMENITIES_GROUPS[group] || []
  );

  setListing((prev) => ({
    ...prev,
    amenities: Array.isArray(prev.amenities)
      ? prev.amenities.filter((a) =>
          allowedItems.includes(a)
        )
      : [],
  }));
}, [propertyType]);


  // ✅ THIS IS THE CRITICAL FIX
  const toggleAmenity = (amenity) => {
    setListing((prev) => {
      const prevAmenities = Array.isArray(prev.amenities)
        ? prev.amenities
        : [];

      return {
        ...prev,
        amenities: prevAmenities.includes(amenity)
          ? prevAmenities.filter((a) => a !== amenity)
          : [...prevAmenities, amenity],
      };
    });
  };

  return (
    <div className="step step-amenities">
      <h2>{t("common.amenities")}</h2>

      {allowedGroups.map((group) => {
  const items =
    propertyType === "land" && LAND_ALLOWED_ITEMS[group]
      ? LAND_ALLOWED_ITEMS[group]
      : AMENITIES_GROUPS[group] || [];

  return (
    <div key={group} className="amenities-group">
      <h4>{t(`amenities.group.${group}`)}</h4>

      {items.map((item) => (
        <label key={item} className="amenity-item">
          <input
            type="checkbox"
            className="amenity-checkbox"
            checked={selectedAmenities.includes(item)}
            onChange={() => toggleAmenity(item)}
          />
          {t(`amenities.items.${item}`)}
        </label>
      ))}
    </div>
  );
})}

      <StepNavigation onBack={onBack} onNext={onNext} />
    </div>
  );
}
